import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import PropTypes from 'prop-types';


const FloatingButtonChild = ({ onClick, type, icon, label }) => {
  let buttonLabel;
  if (label) {
    buttonLabel = <label>{label}</label>;
  }
  const classes = classNames('floating-button', 'floating-menu-icon', `btn-${type}`, 'floating-small');
  return (
    <div className="floating-menu-item">
      {buttonLabel}
      <button type="button" className={classes} onClick={onClick}>
        <span className="button-icon">
          <FontAwesomeIcon icon={{ prefix: 'fal', iconName: icon }} size="2x" />
        </span>
      </button>
    </div>
  );
};


FloatingButtonChild.defaultProps = {
  type: 'dark',
  icon: 'plus'
};

FloatingButtonChild.propTypes = {
  type: PropTypes.oneOf(['warning', 'danger', 'success', 'primary', 'info', 'dark', 'secondary', 'green']),
  icon: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  label: PropTypes.string,
};


export default FloatingButtonChild;
